import { ComponentRef } from '@angular/core';
import { Subject } from 'rxjs';

export class ModalRef<ComponentType> {
    public modalComponentRef: ComponentRef<ComponentType>;
    public onClose: Subject<void>;

    constructor(base: Partial<ModalRef<ComponentType>>) {
        Object.assign(this, base);
    }

    public getComponent(): ComponentType {
        return this.modalComponentRef.instance;
    }
}
